import {getCurrentInstance} from 'vue';

export const useStore = () => {
    const vm = getCurrentInstance();
    if (!vm) {
        throw new Error('useStore must be called inside setup()');
    }
    return vm.proxy.$store;
};